"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var calculateProficiencyPercentage_1 = __importDefault(require("../calculateProficiencyPercentage"));
var constants_1 = require("../../constants");
var NOT_STARTED = constants_1.PROFICIENCY_KEYS.NOT_STARTED, NEEDS_WORK = constants_1.PROFICIENCY_KEYS.NEEDS_WORK, IN_PROGRESS = constants_1.PROFICIENCY_KEYS.IN_PROGRESS, MASTERED = constants_1.PROFICIENCY_KEYS.MASTERED;
function getProficiencyKey(card) {
    var proficiency = card.proficiency, notStarted = card.notStarted;
    if (notStarted || typeof proficiency === 'undefined') {
        return NOT_STARTED;
    }
    var score = calculateProficiencyPercentage_1.default(proficiency);
    if (score < 26) {
        return NEEDS_WORK;
    }
    if (score < 75) {
        return IN_PROGRESS;
    }
    return MASTERED;
}
exports.default = getProficiencyKey;
//# sourceMappingURL=getProficiencyKey.js.map